import { render, staticRenderFns } from "./LOBCostsParent.vue?vue&type=template&id=1aa49f9a&scoped=true&"
import script from "./LOBCostsParent.vue?vue&type=script&lang=js&"
export * from "./LOBCostsParent.vue?vue&type=script&lang=js&"
import style0 from "./LOBCostsParent.vue?vue&type=style&index=0&id=1aa49f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa49f9a",
  null
  
)

export default component.exports